import { render, staticRenderFns } from "./FormationCouncils.vue?vue&type=template&id=6eb7c5a0&scoped=true&"
import script from "./FormationCouncils.vue?vue&type=script&lang=js&"
export * from "./FormationCouncils.vue?vue&type=script&lang=js&"
import style0 from "./FormationCouncils.vue?vue&type=style&index=0&id=6eb7c5a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb7c5a0",
  null
  
)

export default component.exports